import { INSTA_USERNAME, PHONE_NUMBER } from "../../constants/ProductConstants";

const EMAIL = "ontopcherry2025@gmail.com";
const LOCATION = "Mission compound, Saharanpur, U.P";
const INSTAGRAM_URL = `https://www.instagram.com/${INSTA_USERNAME}/`;
const WHATSAPP_URL = `https://wa.me/${PHONE_NUMBER}`;

const styles = {
  page: {
    width: "100%",
    maxWidth: 1100,
    margin: "0 auto",
    padding: "28px 16px 64px 16px",
    boxSizing: "border-box"
  },
  introBlock: {
    textAlign: "center",
    marginBottom: 28
  },
  title: {
    margin: 0,
    fontSize: "clamp(28px, 4vw, 38px)",
    color: "#C21833",
    fontWeight: 600,
    letterSpacing: "0.4px"
  },
  subtitle: {
    margin: "12px auto 0 auto",
    maxWidth: 760,
    color: "#4a5568",
    fontSize: 16,
    lineHeight: 1.7
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: 18,
    alignItems: "stretch"
  },
  card: {
    background: "#fff",
    border: "1px solid #eedede",
    boxShadow: "0 8px 24px rgba(194,24,51,0.08)",
    padding: "20px 18px",
    boxSizing: "border-box",
    minHeight: 150
  },
  cardTitle: {
    margin: "0 0 14px 0",
    color: "#2d3748",
    fontSize: 18,
    fontWeight: 600
  },
  row: {
    display: "flex",
    gap: 10,
    alignItems: "flex-start",
    marginBottom: 12
  },
  icon: {
    display: "inline-flex",
    width: 20,
    minWidth: 20,
    marginTop: 2
  },
  text: {
    margin: 0,
    color: "#4a5568",
    fontSize: 15,
    lineHeight: 1.6,
    overflowWrap: "anywhere"
  },
  link: {
    color: "#C21833",
    textDecoration: "none",
    fontWeight: 600
  },
  socialWrap: {
    display: "flex",
    gap: 12,
    marginTop: 8
  },
  socialBtn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 44,
    height: 44,
    borderRadius: "50%",
    background: "#fff",
    border: "1px solid #eedede",
    boxShadow: "0 2px 10px rgba(194,24,51,0.08)",
    textDecoration: "none"
  },
  noteCard: {
    marginTop: 18,
    padding: "20px 18px",
    background: "linear-gradient(135deg, #fff 0%, #fff6f6 100%)",
    border: "1px solid #f2dada"
  },
  noteTitle: {
    margin: 0,
    color: "#C21833",
    fontWeight: 600,
    fontSize: 17
  },
  noteText: {
    margin: "10px 0 0 0",
    color: "#4a5568",
    lineHeight: 1.7,
    fontSize: 15
  }
};

export default function ContactPage() {
  return (
    <section style={styles.page}>
      <div style={styles.introBlock}>
        <h1 style={styles.title}>Contact Us</h1>
        <p style={styles.subtitle}>
          We love hearing from you. For orders, product queries, custom requests, or support,
          please reach out through any of the channels below and our team will get back to you quickly.
        </p>
      </div>

      <div style={styles.grid}>
        <article style={styles.card}>
          <h2 style={styles.cardTitle}>Get In Touch</h2>

          <div style={styles.row}>
            <span style={styles.icon}>
              <svg width="18" height="18" fill="none" stroke="#C21833" strokeWidth="2" viewBox="0 0 24 24"><rect width="20" height="16" x="2" y="4" rx="2" /><polyline points="22,6 12,13 2,6" /></svg>
            </span>
            <p style={styles.text}>
              <a href={`mailto:${EMAIL}`} style={styles.link}>{EMAIL}</a>
            </p>
          </div>

          <div style={styles.row}>
            <span style={styles.icon}>
              <svg width="18" height="18" fill="none" stroke="#C21833" strokeWidth="2" viewBox="0 0 24 24"><path d="M22 16.92V21a2 2 0 0 1-2.18 2A19.72 19.72 0 0 1 3 5.18 2 2 0 0 1 5 3h4.09a2 2 0 0 1 2 1.72c.13 1.13.37 2.23.72 3.28a2 2 0 0 1-.45 2.11l-1.27 1.27a16 16 0 0 0 6.29 6.29l1.27-1.27a2 2 0 0 1 2.11-.45c1.05.35 2.15.59 3.28.72A2 2 0 0 1 22 16.92z" /></svg>
            </span>
            <p style={styles.text}>
              <a href={`tel:+91${PHONE_NUMBER}`} style={styles.link}>+91 {PHONE_NUMBER}</a>
            </p>
          </div>

          <div style={styles.row}>
            <span style={styles.icon}>
              <svg width="18" height="18" fill="none" stroke="#C21833" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z" /><circle cx="12" cy="10" r="3" /></svg>
            </span>
            <p style={styles.text}>{LOCATION}</p>
          </div>
        </article>

        <article style={styles.card}>
          <h2 style={styles.cardTitle}>Social Media</h2>
          <p style={styles.text}>Connect with us on Instagram and WhatsApp for the latest drops and quick support.</p>

          <div style={styles.socialWrap}>
            <a href={INSTAGRAM_URL} style={styles.socialBtn} aria-label="Instagram" target="_blank" rel="noopener noreferrer">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#C21833" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" /><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" /><line x1="17.5" y1="6.5" x2="17.5" y2="6.5" /></svg>
            </a>
            <a href={WHATSAPP_URL} style={styles.socialBtn} aria-label="WhatsApp" target="_blank" rel="noopener noreferrer">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="#25D366" aria-hidden="true">
                <path d="M12.04 2.003a9.943 9.943 0 0 0-8.62 14.95L2 22l5.217-1.37a9.957 9.957 0 0 0 4.823 1.233h.004a9.95 9.95 0 0 0 9.95-9.95 9.944 9.944 0 0 0-2.913-7.048A9.935 9.935 0 0 0 12.04 2.003zm5.72 14.302c-.241.676-1.396 1.293-1.93 1.379-.494.078-1.12.111-1.807-.108-.417-.133-.95-.31-1.64-.607-2.886-1.247-4.773-4.153-4.918-4.35-.148-.197-1.173-1.56-1.173-2.976 0-1.417.743-2.112 1.006-2.397.263-.285.574-.356.765-.356.191 0 .383.002.551.01.177.008.414-.067.648.495.241.58.821 2.005.893 2.15.071.146.12.316.024.514-.096.198-.144.32-.287.492-.145.174-.304.388-.434.522-.145.148-.296.307-.127.603.17.295.756 1.244 1.622 2.014 1.114.99 2.055 1.296 2.35 1.443.295.148.467.127.64-.076.174-.204.742-.866.94-1.162.198-.295.398-.246.674-.148.277.099 1.758.829 2.058.979.3.148.502.222.574.345.072.124.072.718-.168 1.395z" />
              </svg>
            </a>
          </div>
        </article>
      </div>

      <article style={{ ...styles.card, ...styles.noteCard }}>
        <h3 style={styles.noteTitle}>Response Time</h3>
        <p style={styles.noteText}>
          We typically respond within 24 hours. For faster updates on order-related questions,
          WhatsApp is the best channel.
        </p>
      </article>
    </section>
  );
}
